import request from '../utils/request';

class DashboardService {
  static async getStatistics() {
    try {
      const [overviewRes, usersRes, productsRes, ordersRes, salesRes] = await Promise.all([
        request.get('/admin/stats/overview'),
        request.get('/admin/stats/users'),
        request.get('/admin/stats/products'),
        request.get('/admin/stats/orders'),
        request.get('/admin/stats/sales'),
      ]);

      const overview = overviewRes?.data || {};
      const users = usersRes?.data || {};
      const products = productsRes?.data || {};
      const orders = ordersRes?.data || {};
      const sales = salesRes?.data || {};

      const dailyTotal = (sales.daily || []).reduce((sum, d) => sum + parseFloat(d.total || 0), 0);
      const todaySales = (sales.daily || []).slice(-1)[0]?.total || 0;

      return {
        orders: {
          total: overview.orderCount ?? orders.total ?? 0,
          today: orders.today ?? 0,
          trend: 0,
        },
        users: {
          total: overview.userCount ?? users.total ?? 0,
          today: users.today ?? 0,
          trend: 0,
        },
        products: {
          total: overview.productCount ?? 0,
          active: products.hot?.length ?? 0,
          trend: 0,
        },
        sales: {
          total: dailyTotal,
          today: parseFloat(todaySales) || 0,
          trend: 0,
        },
      };
    } catch (error) {
      console.error('获取统计数据失败:', error);
      return {
        orders: { total: 0, today: 0, trend: 0 },
        users: { total: 0, today: 0, trend: 0 },
        products: { total: 0, active: 0, trend: 0 },
        sales: { total: 0, today: 0, trend: 0 },
      };
    }
  }

  static async getRecentOrders(limit = 5) {
    try {
      const response = await request.get('/admin/order/list', {
        params: { page: 1, pageSize: limit },
      });
      return response.data?.list || response.data?.rows || [];
    } catch (error) {
      console.error('获取最近订单失败:', error);
      return [];
    }
  }

  static async getNotifications() {
    return [];
  }

  static async getSystemStatus() {
    return { cpu: 0, memory: 0, disk: 0, uptime: 0, online: true };
  }

  static async getHotProducts() {
    try {
      const response = await request.get('/admin/stats/products');
      return { data: response.data?.hot || [] };
    } catch (error) {
      console.error('获取热销商品失败:', error);
      return { data: [] };
    }
  }

  static async getUserGrowthTrend() {
    return [];
  }

  static async getSalesTrend() {
    try {
      const response = await request.get('/admin/stats/sales');
      const daily = response.data?.daily || [];
      return {
        data: {
          trend: daily.map((d) => ({ date: d.date, amount: d.total })),
          summary: { total: daily.reduce((s, d) => s + parseFloat(d.total || 0), 0) },
        },
      };
    } catch (error) {
      console.error('获取销售趋势失败:', error);
      return { data: { trend: [], summary: {} } };
    }
  }
}

export default DashboardService;
